import {
    ComponentFactoryResolver,
    ComponentRef,
    Directive,
    Injector,
    OnDestroy,
    OnInit
} from '@angular/core';
import { LeafletDirective } from '@asymmetrik/ngx-leaflet';

import { Icon, Map, Marker } from 'leaflet';
import { MarkerPopupComponent } from '../components/marker-popup/marker-popup.component';

@Directive({
    selector: 'map-context-menu'
})
export class MarkerPopupDirective implements OnInit, OnDestroy {
    // Leaflet map object
    leafletMap: Map;

    // Leaflet directive ref object
    leafletDirective: LeafletDirective;

    // Marker elements
    popupIcon = new Icon({ iconUrl: '.', shadowUrl: '.' });
    popupMarker = new Marker([0, 0], { icon: this.popupIcon });
    popupComponent: ComponentRef<MarkerPopupComponent>;

    constructor(
        private resolver: ComponentFactoryResolver,
        private injector: Injector,
        leafletDirective: LeafletDirective
    ) {
        this.leafletDirective = leafletDirective;
    }

    ngOnInit() {
        this.leafletMap = this.leafletDirective.getMap();

        const factory = this.resolver.resolveComponentFactory(MarkerPopupComponent);
        const props = { autoClose: false, className: 'onclick-map-popup' };

        // Insert component into the popup content
        this.popupComponent = factory.create(this.injector);
        this.popupMarker.bindPopup(this.popupComponent.location.nativeElement, props);

        // Share with the component Leaflet refs
        this.popupComponent.instance.leafletMap = this.leafletMap;
        this.popupComponent.instance.popupMarker = this.popupMarker;

        // Append marker into the map
        this.leafletMap.addLayer(this.popupMarker);

        // Event on right-click / hold touch
        this.leafletMap.on('contextmenu', (e: any) => {
            // Send new location
            this.popupComponent.instance.latlng = e.latlng;
            // Move marker
            this.popupMarker.setLatLng(e.latlng);
            this.popupMarker.openPopup();
        });
    }

    ngOnDestroy() {
        this.leafletMap.removeLayer(this.popupMarker);
        this.popupComponent.destroy();
    }
}
